const CropListing = {

    // FIELDS
    "crop": "Crop",
    "quantity": "Quantity (kg)",
    "district": "District",
    "tehsil": "Tehsil",
    "image": "Image",
    "description": "Description",
    "crop_availability": "Crop Availability",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "crop_listing": "Crop Listing",
    "marketplace_view": "Marketplace View",

    // ERROR
    "error_crop": "Select Crop",
    "error_quantity": "Enter Quantity in kg",
    "error_quantity_type_error": "Enter only positive number",
    "error_district": "Select District",
    "error_tehsil": "Select Tehsil",
    "error_image": "Choose Image",
    "error_description": "Enter Description",

    // TABLE HEADER
    "table_image": 'IMAGE',
    "table_crop": 'CROP',
    "table_quantity": 'QUANTITY (kg)',
    "table_district": 'DISTRICT',
    "table_tehsil": 'TEHSIL',
    "table_status": "STATUS",

}

export default CropListing;